import { useAppStore } from '@/shared/store/app.store.ts'
import { WorkflowId } from '@/models'
import type { InternalDataInput } from './internal-data.ts'

export const getProEditorInternalData = (): InternalDataInput => {
  const sessionId = useAppStore.getState().session?.sessionId ?? ''

  return {
    workflow_name: WorkflowId.PRO_EDITOR,
    module_name: WorkflowId.PRO_EDITOR,
    workflow_session_id: sessionId,
    module_session_id: sessionId,
  }
}
